import { buyerCurrencyFormatter } from '@diamond/shared/utils';

/**
 * Formats discount amount for banner display
 * @param deductionAmount - The deduction amount in basis points (for percentage) or rupiah (for amount)
 * @param isDiscount - Whether this is a percentage discount (true) or amount discount (false)
 * @returns Formatted string: "DISKON 20%" or "DISKON Rp50.000"
 */
export function formatDiscountDisplay(
  deductionAmount: number,
  isDiscount: boolean
): string {
  if (isDiscount) {
    // For percentage discount: deductionAmount is in basis points (e.g., 500 = 5%)
    const percentage = deductionAmount / 100;
    return `DISKON ${percentage}%`;
  } else {
    // For amount discount: deductionAmount is already in rupiah (e.g., 10000 = Rp10.000)
    return `DISKON ${buyerCurrencyFormatter(deductionAmount)}`;
  }
}
